import React, { useState, useEffect } from 'react';
import { FaTimes, FaSave } from 'react-icons/fa';

const EditLinkModal = ({ isOpen, onClose, link, onSave }) => {
    const [editedLink, setEditedLink] = useState(link);

    useEffect(() => {
        setEditedLink(link);
    }, [link]);

    if (!isOpen || !editedLink) {
        return null;
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedLink(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(editedLink.id, editedLink);
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Modifier le Lien</h2>
                <button onClick={onClose} className="modal-close-button">
                    <FaTimes />
                </button>
                <form onSubmit={handleSubmit} className="link-form">
                    <div className="groupee">
                        <div className="form-group gr">
                            <label>Prénom de l'ambassadeur:</label>
                            <input
                                type="text"
                                name="ambassadeur_prenom"
                                value={editedLink.ambassadeur_prenom || ""}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form-group gr">
                            <label>Nom de l'ambassadeur:</label>
                            <input
                                type="text"
                                name="ambassadeur_nom"
                                value={editedLink.ambassadeur_nom || ""}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form-group gr">
                            <label>Email de l'ambassadeur:</label>
                            <input
                                type="email"
                                name="ambassadeur_email"
                                value={editedLink.ambassadeur_email || ""}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form-group gr">
                            <label>URL de destination:</label>
                            <input
                                type="text"
                                name="url_destination"
                                value={editedLink.url_destination || ""}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form-group gr">
                            <label>Code court:</label>
                            <input
                                type="text"
                                name="code_court"
                                value={editedLink.code_court || ""}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        {editedLink.type_lien === "personnalise" && (
                            <div className="form-group gr">
                                <label>Valide jusqu'au:</label>
                                <input
                                    type="date"
                                    name="valide_jusqu_a"
                                    value={
                                        editedLink.valide_jusqu_a
                                            ? editedLink.valide_jusqu_a.split(
                                                  "T"
                                              )[0]
                                            : ""
                                    }
                                    onChange={handleInputChange}
                                />
                            </div>
                        )}
                        <button
                            type="submit"
                            className="action-btn btn-save gr"
                        >
                            <FaSave /> Enregistrer les modifications
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditLinkModal;
